const init = (instance, $section) => {
    instance.$section = $section;
    instance.$openBtn = $section.querySelector('.header-live__button--show-all');
    instance.isActive = $section.classList.contains('header-live--opened');

    if (instance.$openBtn) {
        instance.$openBtn.addEventListener('click', event => {
            event.preventDefault();
            instance.toggleList();
        });
    }
};

export default class HeaderLive {
    constructor($section) {
        this.$section = null;
        this.$openBtn = null;
        this.isActive = false;

        return $section ? init(this, $section) : {};
    }

    toggleList() {
        this.isActive ? this.hideList() : this.showList();
    }

    showList() {
        this.$section.classList.add('header-live--opened');
        this.isActive = true;
    }

    hideList() {
        this.$section.classList.remove('header-live--opened');
        this.isActive = false;
    }
}